import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { ISaleSoDetail } from './bmsBillSaleSoType';

class SaleSoService {
	async one(id: string) {
		const apiUrl = `/bcm/sale/findById/${id}`;
		return await appHttpRequest.get<ISaleSoDetail>(apiUrl);
	}
}

export const saleSoService = new SaleSoService();
